import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  workingHours: [],
  workingHour: null,
};

export default {
  namespaced: true,
  name: "workingHours",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_WORKING_HOURS](state, payload = []) {
      state.workingHours = payload;
    },
    [actions.GET_WORKING_HOUR](state, payload = null) {
      state.workingHour = payload;
    },
    [actions.UPDATE_WORKING_HOUR](state, payload = null) {
      state.workingHour = payload;
    },
    [actions.RESET_WORKING_HOUR_FORM](state) {
      state.workingHour = null;
    },
  },
  actions: {
    async fetchWorkingHours({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.workingHours.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_WORKING_HOURS, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_WORKING_HOURS, []);
          reject(error);
        }
      });
    },
    async fetchWorkingHour({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.workingHours.single(payload),
            "GET"
          );
          commit(actions.GET_WORKING_HOUR, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_WORKING_HOUR, null);
          reject(error);
        }
      });
    },
    async updateWorkingHour({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.workingHours.single(payload.id),
            "PUT",
            payload
          );
          commit(actions.UPDATE_WORKING_HOUR, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_WORKING_HOUR_FORM);
    },
  },
};
